<template>
  <div class="container-register">
    <span class="title">Register</span>
    <div class="step-title">
      <div style="marginBottom:20px">Step {{registerStep}} {{stepTitle}} </div>
      <div style="display:flex; justifyContent: center;marginBottom:25px">
        <div v-for="(item, index) in 2" class="step-point" :key="index" :class="{step_point_active: registerStep >= (index + 1)}"></div>
      </div>

    </div>
    <div class="form-container" >
      <Form ref="formInline" :model="formInline" :rules="ruleInline" v-if="registerStep == 1" key="formInline">

        <FormItem prop="login">
          <Input
            type="text"
            v-model="formInline.login"
            placeholder="Login"
            size="large"
          >
          </Input>
        </FormItem>
        
        <div>
          <div style="display:flex;">

            <FormItem style="marginRight:10px" prop="firstName">
              <Input
                type="text"
                v-model="formInline.firstName"
                placeholder="First name"
                size="large"
              >
              </Input>
            </FormItem>

            <FormItem prop="lastName">
              <Input
                type="text"
                v-model="formInline.lastName"
                placeholder="Last name"
                size="large"
              >
              </Input>
            </FormItem>

          </div>
        </div>

        <FormItem prop="password">
          <Input
            type="password"
            v-model="formInline.password"
            placeholder="Password"
            size="large"
            password
          >
          </Input>
        </FormItem>

        <FormItem prop="confirmPassword">
          <Input
            type="password"
            v-model="formInline.confirmPassword"
            placeholder="Confirm password"
            size="large"
            password
          >        
          </Input>
        </FormItem>

        <FormItem prop="email">
          <Input
            type="email"
            v-model="formInline.email"
            placeholder="Email"
            size="large"
          >
          </Input>
        </FormItem>

        <FormItem prop="phone">
          <Input
            type="tel"
            v-model="formInline.phone"
            placeholder="Mobile phone"
            size="large"
          >
          </Input>
        </FormItem>

        <p v-if="error && error.length" class="text-error">{{error}}</p>  
        <button class="btn"  @click.prevent="handleSubmit('formInline')">Continue</button>
        
      </Form>

      <!-- step 2 -->
      <Form ref="formWallet" :model="formWallet" :rules="ruleWallet" v-else-if="registerStep == 2" key="formWallet">

        <FormItem prop="bcrWallet" >
          <Input
            type="text"
            v-model="formWallet.bcrWallet"
            placeholder="BCR account address"
            size="large"           
          >
          </Input>        
        </FormItem>
        <FormItem prop="bcrWalletBalance" >
          <Input
            type="text"
            v-model="formWallet.bcrWalletBalance"
            placeholder="Requested TPR balance"
            size="large"           
          >
          </Input>        
        </FormItem>

         <FormItem prop="tprWallet">
            <Input
              type="text"
              v-model="formWallet.tprWallet"
              placeholder="TPR wallet address"
              size="large"
            >          
            </Input>
          </FormItem>

         <p v-if="error && error.length" class="text-error">{{error}}</p>
         <button class="btn"  @click.prevent="handleSubmit('formWallet')" style="marginBottom:10px">Register</button>
         <p class="arrow-back"  @click="goBack">
           <Icon type="ios-arrow-back" />
           Back
         </p>
      </Form> 
     
    </div>

    <Modal
        v-model="modalTerms"
        width="815"
        :footer-hide="footerHide"
        :closable = false
        >
        <div class="text">
          <h1 slot="header" style="textAlign:center;marginBottom:30px">Terms & Conditions</h1>
          <h2 class="h1">THE PEOPLE’S RESERVE</h2>
          <p>This website is owned and operated by THE PEOPLE’S RESERVE PTY LLC (referred to in these terms and conditions as <strong>‘TPR’, ‘we’, ‘us’, or ‘our’</strong> ). TPR is a company limited by shares, incorporated in Belize, and regulated by the Laws of Belize.</p>
          <h3>ABOUT THESE TERMS</h3>
          <p>By using this website and its cryptocurrency services (<strong>Services</strong>), or by using any marketing materials (such as, but not limited to, information sheets, guides, articles, or emails) we make available to users (referred to in these terms and conditions as ‘<strong>you</strong>’ or ‘<strong>your</strong>’) through our website, social media, via email, or any other online channel, you agree to be bound by the terms and conditions (<strong>Terms</strong>) set out on this webpage.</p>
          <p>These Terms constitute a legal agreement and create a binding contract between you and TPR. Please read the Terms carefully as they govern your use of TPR Services. By accessing, using, or attempting to use TPR Services in any capacity, you acknowledge that you accept and agree to be bound by these Terms. If you do not agree, you must refrain from using the Services.</p>
          <p>Due to the rapid technological, legal, and social development of digital currencies and blockchain technologies, these Terms between you and TPR do not enumerate or cover exhaustively all rights and obligations of each party, and do not guarantee full alignment with needs arising from future development. Therefore, TPR’s Privacy Policy (<a href="https://thepeoplesreserve.com/privacy-policy" target="_blank">https://thepeoplesreserve.com/privacy-policy</a> ) and all other agreements entered into separately between you and TPR are deemed supplementary Terms that are an integral part of these Terms and have identical legal effect. Your use of the TPR website and Services equates to your acceptance of these such supplementary Terms.</p>         
          <p>We may review and update these Terms at any time, including to take account of new laws, products, or technology. Your continued use of the website following such updates will represent an agreement by you to be bound by the terms and conditions as amended.</p>
          <p>By accessing TPR Services, you agree that TPR has the right to investigate any violation of these Terms, unilaterally determine whether you have violated these Terms, and take actions under relevant regulations without your consent or prior notice.</p>
          <p>If any provision of these Terms are held, for any reason, to be invalid, unenforceable, or illegal, the remaining parts of these Terms will remain in full force and effect.</p>
          <h3>ACCOUNT REGISTRATION AND REQUIREMENTS</h3>

          <p>You must apply for a TPR account before using TPR Services. When you register a TPR account, you must provide personal details, including, but not limited to, your real name, password, email address, mobile number, government-issued proof of identification, proof of residency, and you must accept these Terms and the Privacy Policy. TPR may refuse, at our discretion, to open a TPR account for you. You agree to provide complete and accurate information when opening a TPR account, and agree to update, in a timely manner, any information you provide to TPR to maintain the integrity and accuracy of the information.</p>
          <p>Your registration of an account with TPR will be deemed your agreement to provide this such required personal information for identity verification. Such information will be used to verify your identity, identify traces of money laundering, terrorist financing, fraud and other financial crimes through TPR, or for other lawful purposes stated by TPR. We will collect, use, and share such information in accordance with our Privacy Policy. In addition to providing such information, you agree to allow us to keep a record of that information during the period for which your account is active and within five (5) years after your account is closed, in compliance with global industry standards on data storage. You also authorise TPR to conduct necessary investigations directly or through a third party to verify your identity or protect you and/or us from financial crimes such as fraud.</p>
          <p>Your personal data will be properly protected and kept confidential. However, TPR reserves the right to collect, process, use or disclose your personal data to third parties, including, but not limited to, your transaction counterparty, our joint ventures, alliance partners, business partners, and professional consultants such as auditors and lawyers, in accordance with the Terms (including the Privacy Policy) or applicable laws, depending on the products or Services concerned.</p>
          <p>If there are any grounds for believing that any of the information you provided is incorrect, false, outdated, or incomplete, TPR reserves the right to send you a notice to demand correction, directly delete the relevant information, and, as the case may be, terminate all or part of relevant TPR Services provided for you by TPR. If we are unable to reach you with the contact information you provided, you are fully liable for any loss or expense caused to TPR during your use of TPR Services.</p>
          <p>By registering to use a TPR Account, you represent and warrant that:</p>
          <ol>
            <li>as an individual, you are at least 18 or are of legal age to form a binding contract under applicable laws;</li>
            <li>as an individual, legal person, or other organisation, you have full legal capacity and sufficient authorisations to enter into these Terms;</li>
            <li>you have not been previously suspended or removed from using TPR Services;</li>
            <li>if you act as an employee or agent of a legal entity, and enter into these Terms on their behalf, you represent and warrant that you have all the necessary rights and authorisations to bind such legal entity;</li>
            <li>your use of TPR Services will not violate any and all laws and regulations applicable to you, including, but not limited to, regulations on anti-money laundering, anti-corruption, and counter-terrorism financing.</li>
          </ol>
          <p>A TPR account can only be used by the account registrant. TPR reserves the right to suspend, freeze, or cancel the use of a TPR account by persons other than account registrant. If you suspect or become aware of any unauthorised use of your username and password, you should notify TPR immediately. TPR assumes no liability for any loss or damage arising from the use of a TPR account by you or any third party with or without your authorisation</p>
          <p>TPR reserves the right to suspend, limit, restrict, deactivate, or terminate your access to TPR’s website and Services, including your account, for reasons including, but not limited to:</p>
          <ol  style="list-style: lower-alpha">
            <li>there being a technical or operational difficulty;</li>
            <li>your use of our platform or Services being subject to any pending investigation, litigation, or proceeding;</li>
            <li>your use of our platform or Services being found to be related to the performance of illegal or criminal activities; or</li>
            <li>a breach by you of any of these Terms or our Privacy Policy</li>
          </ol>
          <h3>LIABILITY</h3>
          <p>To the maximum extent permitted under applicable law, TPR Services and any material, product, service, or other item provided by or on behalf of TPR are offered on an ‘as is’ and ‘as available’ basis, and TPR expressly disclaims, and you waive, any and all other warranties of any kind, whether express or implied, including, without limitation, warranties of merchantability, fitness for a particular purpose, title or non-infringement or warranties arising from course of performance, course of dealing or usage in trade. Without limiting the foregoing, TPR does not represent or warrant that the site or TPR Services are accurate, complete, reliable, current, error-free, or free of viruses or other harmful components. TPR does not guarantee that any order will be executed, accepted, recorded, or remain open. </p>
          <p>By using TPR’s website and Services, you understand and agree that TPR will not be liable for any losses or damages arising out of or relating to:</p>
          <ol style="list-style: lower-alpha">
            <li>any inaccuracy, defect or omission of digital assets price data;</li>
            <li>any error or delay in the transmission of such data;</li>
            <li>interruption in any such data;</li>
            <li>service interruption and change resulting from maintenance by TPR of the website or the Services;</li>
            <li>any damages incurred by other users’ actions, omissions, or violation of these terms;</li>
            <li>any damage caused by illegal actions of other third parties or actions without authorised by TPR; and</li>
            <li>other exemptions mentioned in any other disclaimers and rules issued by TPR.</li>
          </ol>
          <p>You agree to indemnify TPR and our affiliates, contractors, licensors, and their respective directors, officers, employees, and agents from and against any claims, actions, proceedings, investigations, demands, suits, costs, expenses and damages (including legal fees, fines, or penalties imposed by any regulatory authority) arising out of or related to:</p>
          <ol style="list-style: lower-alpha">
            <li>your use of, or conduct in connection with, TPR Services;</li>
            <li>your breach or our enforcement of these Terms; or</li>
            <li>your violation of any applicable law, regulation, or rights of any third party during your use of TPR Services.</li>
          </ol>
          <p>If you are obligated to indemnify TPR or our affiliates, contractors, licensors, and their respective directors, officers, employees, or agents pursuant to these Terms, TPR will have the right, at our sole discretion, to control any action or proceeding and to determine whether TPR wishes to settle, and if so, on what terms.</p>
          <h3>PROVISION OF SERVICES</h3>
          <p>Certain products and services may be available exclusively online through our website.</p>
          <p>Services are subject to change, and include, but are not limited to, TPR providing to Bankcoin Reserve (‘<strong>BCR</strong> ’) Coin holders the opportunity to receive TPR Coins. Not all BCR holders shall be awarded with TPR. TPR reserves its right to award BCR holders with TPR at their sole discretion.</p>
          <p>Per this Service, TPR will provide TPR Coins free of charge to BCR Coin holders. The amount of TPR coins deposited will differ proportionately based on the BCR wallet holdings of each individual holder.</p>
          <p>By using this Service, you agree that:</p>
          <ol style="list-style: lower-alpha">
            <li>to the maximum extent permitted by law, you waive any liability of TPR against any loss, damage, or information leakage suffered as a result of your use of the Service;</li>
            <li>to the maximum extent permitted by law, you waive any liability stemmed from BCR in the provision of this Service;</li>
            <li>to the maximum extent permitted by law, you waive any liability from TPR and it’s associated employees, members, advocates and affiliates from anything in relation to BCR ecosystem and coin;</li>
            <li>there is no guarantee by TPR as to the price or value of TPR Coins;</li>
            <li>any relevant taxation liabilities belong solely to you, as the taxation holder, and that it is your responsibility to seek professional tax advice and/or determine whether, and to what extent, any taxes apply to any transactions or trades you conduct through our Services;</li>
            <li>when the TPR issuance process is closed, there is no entitlement to the free of charge TPR coins; and</li>
            <li>certain conditions may arise that are to be met in order for BCR Coin holders to continue to be eligible to receive the free of charge TPR Coins, including, but not limited to, a required minimum quantity of BCR Coins in their wallet, or the performance of certain tasks such as, but not limited to, sharing information about TPR Coins on a social media forum.</li>
          </ol>
          <h3>USAGE OF SERVICES</h3>
          <p>Provided that you constantly comply with the express terms and conditions stated in these Terms, TPR grants you a revocable, limited, royalty-free, non-exclusive, non-transferable, and non-sublicensable license to access and use TPR Services through your computer or Internet compatible devices for your personal/internal purposes. You are prohibited to use TPR Services for resale or commercial purposes, including transactions on behalf of other persons or entities. All the above actions are expressly prohibited and constitute a material violation of these Terms. TPR reserves all rights not expressly granted in these Terms, thereby prohibiting you from using TPR Services in any way not expressly authorised by these Terms.</p>
          <h3>YOUR GUARANTEE TO TPR</h3>
          <p>You guarantee to TPR: That you are the person you hold yourself out to be; you own any wallet inputted into the TPR website platform or affiliated services of TPR, whether a TPR wallet or a wallet from any other blockchain or relevant protocol; you will not use TPR for illegal purposes; you will not hold TPR liable for any loss of TPR coins; you will not hold TPR liable for the loss of cryptocurrency outside the TPR ecosystem; and you will indemnify TPR for any damages or liability not directly related to TPR’s actions.  </p>
          <h3>TAXATION</h3>
          <p>Your taxation circumstances are custom to you. Prior to participating you should consult a taxation specialist in your relevant jurisdiction. TPR will not be liable for any tax consequences in relation to your participation.</p>
          <h3>RISKS</h3>
          <p>The issuanceping, trading, or holding of coins, tokens, crypto, digital currency, or digital assets of the like (collectively, ‘<strong>Coins</strong>’) involves significant and exceptional risks, the associated losses of which may be substantial and unlike losses associated with traditional forms of currencies, goods, or commodities. Coins are decentralised and are not backed by a central bank, government, or legal entity, and the issuanceping, trading, and holding of Coins is currently unregulated. As such, the value and price of Coins may fluctuate depending on the market, investor confidence, competing currencies, regulatory announcements or changes, technical issues, and many other factors. TPR does not guarantee the value or price of any Coin on the website and through its associated Services, nor does TPR warrant or guarantee that particular Coins, or issuanceping/trading processes will always remain available on our platform and through our Services. </p>
          <p>You should carefully consider and assess whether the issuanceping, trading, or holding of Coins is suitable for you depending upon your financial circumstances, knowledge of the industry and market, and tolerance to risk. Your usage of TPR’s website and Services equates to the acknowledgement of the variety of risks associated with issuanceping, trading, and holding Coins.</p>
          <p>TPR is not responsible or liable for any Coins once they are transferred from our Platform to another site, device, platform, or user, nor is TPR responsible or liable for any Coins not issuanceped or traded on our platform that have been sent into our platform, or Coins that have been sent to an incorrect wallet address or a wallet address for a different Coin. You are responsible for familiarising yourself with the security measures available and warnings to be noted when using wallet services or other devices for storage, and waive TPR of any responsibility associated with the misappropriation, loss, or theft of your Coins.</p>
          <h3>EXTERNAL LINKS</h3>
          <p>Our website or Services may contain links to websites operated by third parties. Those links may not remain current or be maintained. Unless expressly stated otherwise, we do not endorse and are not responsible or liable for the content on those linked websites or any loss you may suffer on those linked sites, and have no control over, or rights in those linked websites.</p>
          <h3>PRIVACY</h3>
          <p>Any personal information submitted by you (whether personal information of you or another individual which you have the necessary consent to provide) to TPR is subject to and may be handled in accordance with our Privacy Policy, which can be found at <a href="https://thepeoplesreserve.com/privacy-policy" target="_blank">https://thepeoplesreserve.com/privacy-policy</a> . You agree that, by using our website or communicating with us, you have read the Privacy Policy, understood its contents, and consented to its requirements</p>
          <h3>INTELLECTUAL PROPERTY</h3>
          <p>These Terms only grant a limited license to access and use TPR Services. Therefore, you hereby agree that, when you use TPR Services, TPR does not transfer TPR Services or the ownership or intellectual property rights of any TPR intellectual property to you or anyone else. All materials on this website or as part of its Services, including, but not limited to, text, graphics, user interfaces, visual interface, photos, sounds, process flow diagrams, computer code (including HTML code), programs, software, products, information, and documents, as well as the design, structure, selection, coordination, expression, look and feel, and layout of any content included in the services or provided through TPR Services, are exclusively owned, controlled and/or licensed by TPR or its affiliates, unless otherwise indicated.</p>
          <p>You may only access and use these materials for non-commercial or personal use, except to the extent permitted by law or where you have received prior written approval from us. If you would like approval to use our website materials, please contact <a href="mailto:support@thepeoplesreserve.com"> support@thepeoplesreserve.com </a>. </p>
          <p>Reference on TPR’s website or through our Services to any companies, products, services, branding, offers, or other information, by trade name, trademark, or otherwise, does not constitute or imply endorsement, sponsorship, or recommendation by us or the respective trademark owner. </p>
          <h3>JURISDICTION</h3>
          <p>Your use of the website and these terms and conditions are governed by the laws of Belize.</p>
        </div>
        <div style="paddingTop: 20px">
          <div class="agree">
            <input type="checkbox" id="agree" v-model="agree">
            <label for="agree">I have read and agree to the Privacy Policy and Terms of Use.
              <a href="https://thepeoplesreserve.com/privacy-policy/" target="_blank">Privacy Policy</a>
            </label>
          </div>
          <div class="agree">
            <input type="checkbox" id="whitePaper" v-model="whitePaper">
            <label for="whitePaper">I have read and agree with the whitepaper.
              <a href="https://t9u.263.myftpupload.com/wp-content/uploads/2021/03/The-Peoples-Reserves-Whitepaper-16.03.2021-.pdf" target="_blank">Whitepaper</a>
            </label>
          </div>
          <div class="button-wrapper">
            <button @click.prevent="submit" :disabled="!allAgree">continue</button>
          </div>       

        </div>
    </Modal>

  </div>
</template>

<script>
import { 
  bcrWallet, 
  bcrWalletBalance, 
  tprWallet, 
  login,
  firstName,
  lastName,
  email,
  phone,
  password, 
  validatePasswordConfirm } from '../assets/js/validators';
export default {
  data() {
    const validateRepassword = (rule, value, callback) => validatePasswordConfirm(value, callback, this.formInline.password);

    return {
      docType: '1',
      agree: false,
      whitePaper: false,
      footerHide:true,
      modalTerms: false,
      afterCheckFotoModal: false,
      stepTitle1: "Login Details",
      stepTitle2: "Payment Details",
      stepTitle3: "ID Verification",
      registerStep: 1,
      error: '',
      imageError : {
        frontSide: false,
        backSide: false,
        imageWithFace: false,
        regDoc: false
      },
      fileSize: 10485760,
      formInline: {
        login: "",
        firstName: "",
        lastName: "",
        password: "",
        confirmPassword: "",
        email: "",
        phone: ""
      },
      formWallet: {
        bcrWallet: "",
        bcrWalletBalance: "",
        tprWallet: ""
      },
      formImages: {
        frontSide: "",
        backSide: "",
        imageWithFace: "",
        regDoc: ""
      },
      ruleWallet: {
        bcrWallet,
        bcrWalletBalance,
        tprWallet
      },
      ruleInline: {
        login,
        firstName,
        lastName,
        email,
        phone,
        password,
        confirmPassword: [
          ...password,
          {
            validator: validateRepassword,
            trigger: "blur"
          }
        ],
      },
    };
  },
  computed: {
    stepTitle() {
      if(this.registerStep == 1) {
        return this.stepTitle1
      }else if(this.registerStep == 2){
        return this.stepTitle2
      }else {
        return this.stepTitle3
      }
    },
    getDocumentType() {
      return this.$store.getters.getDocumentType
    },
    getStatusUploadPicture() {
      return this.$store.getters.getStatusUploadPicture
    },
    allAgree() {
      return this.agree && this.whitePaper
    }
  },

  methods: {
    goBack() {
      this.hideError()
      this.registerStep--
    },
    goToLoginPage() {
      this.$router.push('/login')
    },
    terms() {
      this.agree = false
      this.whitePaper = false
      this.modalTerms =true
    },
    showError() {
      this.error = this.formHasEmptyFields() ? 'Please enter all information' : 'Invalid data. Please change it';
    },
    hideError() {
      this.error = ''
    },
    formHasEmptyFields() {
      let currentForm = this.registerStep == 2 ? this.formWallet : this.formInline 
      let fields = Object.values(currentForm)
      return !fields.reduce((acc, field) => acc && field.length, true)
    },
    submit() {
      this.modalTerms =false
      this.$store.commit('setGlobalLoading', true)
       const params = {};
          params["username"] = this.formInline.login;
          params["password"] = this.formInline.password;
          params["first_name"] = this.formInline.firstName; 
          params["last_name"] = this.formInline.lastName;
          params["email"] = this.formInline.email; 
          params["phone"] = this.formInline.phone;
          params["tpr_address"] = this.formWallet.tprWallet; 
          params["bcr_address"] = this.formWallet.bcrWallet;
          params["bcr_balance"] = this.formWallet.bcrWalletBalance;
          params["terms_agree"] = this.agree;
          params["whitepaper_agree"] = this.whitePaper;
       

          if (this.agree && this.valid() && this.whitePaper) {            
            this.$store.dispatch('register', {user: params})
            .then(() => {
              this.$store.commit('setGlobalLoading', false)
              this.$router.push('/thank?fromRgistration=true')
              this.$Message.success("Success!");
            })
            .catch(err => {
              this.$store.commit('setGlobalLoading', false)
              this.$Message.error({
                content: err.response.data['error'],
                duration: 5
              });
            })            
           
          } else {
            if (!this.agree) {
              this.$store.commit('setGlobalLoading', false)
              this.$Message.error({
                content: "You need to agree to the terms & condition!",
                duration: 5
              });
              
            } else {
                this.$store.commit('setGlobalLoading', false)
                this.$Message.error({
                  content: "Please fill in all required fields!",
                  duration: 5
                });
            }
            
          }       
    },
    valid() {
      const valuesInLine = Object.values(this.formInline)
      const values = Object.values(this.formWallet)
      let resultUserData, resultUserWallet 
      for (const iterator of valuesInLine) {
        if (iterator) {
            return resultUserData = true
        } else {
            return resultUserData = false
            break
        }
      }

      for (const iterator of values) {
        if (iterator) {
            return resultUserWallet = true
        } else {
            return resultUserWallet = false
            break
        }
      }
     return resultUserData && resultUserWallet
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {     
        if (valid) {
          this.hideError()
          if (this.registerStep == 1) {
            this.$Message.success("Success!");
            this.changePage()
          } else {
            this.terms()
          }
        } else {
          this.showError()
        }
      });
    },
    changePage() {
      this.registerStep++
    },
   
  },
};
</script>

<style lang="scss" scoped>
.check-foto_container {
  padding: 5px;
  h1 {
    text-align: center;
    margin-bottom: 30px;
  }
  p  {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 40px;
  }
  &-button {
    display: flex;
    justify-content: center;
    button {
      width: 50%;
      background-color: #FFE709;
      text-transform: uppercase;
      border: none;
      border-radius: 4px;
      outline: none;
      padding: 16px;
      cursor: pointer;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
    button + button {
      margin-left: 10px;    
    }
  }
}
.h1 {
  text-align: center;
}
.arrow-back {
  cursor:pointer
}
.agree {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  input {
    margin-right: 15px;
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
}
.button-wrapper {
  display: flex;
  justify-content: center;
  button {
    text-transform: uppercase;
    background-color:#FFE709;
    padding: 12px 28px;
    border: none;
    outline: none;
    cursor: pointer;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
}
.text {
  height: 600px;
  padding: 5px;
  overflow-y: scroll;
  ol {
    list-style-type: lower-roman;
    list-style-position: outside;
    li {
      margin-left: 30px;
      padding: 0  0 0 20px;
    }
  }
  h2, h3, p , ol, li{
    margin-bottom: 10px;
  }
  // border-bottom: 1px solid #000;
}
.container-register {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 430px;
  max-height: 780px;
  padding: 20px;
  background-color: #fff;
  background-image: none;
  box-shadow: 0px 0.1px 0.3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.2);
  .title {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 16px;

  }
  .form-container {
    width: 100%;
  }
  .btn {
    width: 100%;
    background: #FFE709;
    border-radius: 4px;
    outline: none;
    border: none;
    padding: 16px;
    text-transform: uppercase;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    cursor:pointer;
  }
  .step-title {
    .step-point {
      width: 14px;
      height: 14px;
      background: #CBCDFF;
      border-radius: 50px;
      
    }
    .step_point_active {
      background: #FADB08;
    }
    .step-point + .step-point {
      margin-left: 20px;
    }
  }
  .buttonFile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    &_fileInput {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }
    &_lable {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.01em;
      color: black;
      padding: 10px 20px;
      background: #FFE709;
      border-radius: 4px;
      display: inline-block;
      cursor: pointer;
      text-transform: uppercase;
      
    }
    .uploaded {
      color: lightgreen;
    }
    .image_error {
      color: red;      
    }

  }
}
.typeDocument {
  background-color: #fff;
  width: 100%;
  border: 2px solid #FFE709;
  outline: 0;
  border-radius: 4px;
  margin-bottom: 15px;
  cursor: pointer;
  height: 40px;
  margin-top: 10px;

}
.text-error {
  color: #F65858;
  text-align: center;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 20px;
}
@media  (max-width : 900px) {
  .buttonFile_lable {
    font-size:12px !important;
    padding: 10px 16px !important;
    i {
      font-size: 16px !important;
    }
  }
}
</style>


